package app.nestbridge.feature.common.ui

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.karawek.core.ui.components.CorePrimaryButton
import com.karawek.core.ui.theme.CoreTheme
import com.karawek.core.ui.theme.CoreTypography
import com.karawek.core.ui.theme.ThemeMode
import com.karawek.core.ui.theme.ThemeModeProvider
import app.nestbridge.feature.common.screen.DocumentViewerScreen
import app.nestbridge.ui.theme.NestBridgeTheme
import com.slack.circuit.codegen.annotations.CircuitInject
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.tooling.preview.PreviewParameter
import com.karawek.core.ui.components.CoreScaffold
import app.nestbridge.feature.common.screen.DocumentViewerEvent
import app.nestbridge.feature.common.screen.DocumentViewerState
import software.amazon.lastmile.kotlin.inject.anvil.AppScope

@CircuitInject(
    screen = DocumentViewerScreen::class,
    scope = AppScope::class,
)
@Composable
fun DocumentUi(
    state: DocumentViewerState,
    modifier: Modifier = Modifier,
) {
    CoreScaffold(
        title = state.title,
        footer = { Footer(state) },
        onAppear = { state.eventSink(DocumentViewerEvent.OnAppear) },
    ) {
        Text(
            text = if (state.isLoading) "Loading…" else state.content,
            style = CoreTypography.body,
            color = CoreTheme.colors.textPrimary,
        )
    }
}

@Composable
private fun Footer(state: DocumentViewerState) =
    CorePrimaryButton(
        text = "Close",
        onClick = { state.eventSink(DocumentViewerEvent.Close) },
        modifier = Modifier
            .fillMaxWidth(),
    )

@Preview
@Composable
private fun DocumentViewerPreview(
    @PreviewParameter(ThemeModeProvider::class) themeMode: ThemeMode,
) {
    NestBridgeTheme(themeMode = themeMode) {
        DocumentUi(
            state = DocumentViewerState(
                title = "Terms & Conditions",
                content = List(2) {
                    List(16) {
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                    }.joinToString(" ")
                }.joinToString("\n\n"),
                isLoading = false,
            ),
        )
    }
}
